import { Button, Dialog, Grid, Icon, Typography, Select, Tooltip, FormHelperText } from '@material-ui/core'
import React, { useState, useEffect } from 'react'
import { Label } from '../../../../../../components/UiElements/UiElements'
import { InputBaseField } from '../../../../../../components/InputField/InputField'
import { PostDataAPI } from '../../../../../../Services/APIService';
import { validateEmail, handleNumberKeyPress, IsVerizonSIM } from '../../../../../../../src/components/Common/Extensions';
import { withSnackbar } from "./../../../../../../components/Message/Alert";
import { lstStates, lstCountry, lstMonths } from '../../../../../../../src/components/Common/Lookup';
import axios from 'axios';
import { GetUserInfo } from "../../../../../../Services/GetUserInfo";
import useStyles from "./styles";
function LineInformation({ handleNext, triggerLineInfoNext, updateTrigger, msisdn, data, isPrepaid, simPrice, setLoaderVisible,
    setLoaderHide, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    data.activationPlanId = data.activationPlanId ? data.activationPlanId.toString() : '';
    const [state, setState] = useState(data);
    const [wirelessPlans, setWirelessPlans] = useState([]);
    const [lstAllWirelessPlans, setLstAllWirelessPlans] = useState([]);
    let user_info = JSON.parse(GetUserInfo());
    const [accountNumber] = useState(user_info.user.accountNumber);

    const [errorMessages, setErrorMessages] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    debugger
    const handleChange = (e) => {
        const { name, value } = e.target;

        setState((prevState) => ({
            ...prevState,
            [name]: value,

        }));
        if (name == 'icc' && value && value.length >= 9) {
            var isVerzion = IsVerizonSIM(value);
            setWirelessPlans(lstAllWirelessPlans
                .filter(a => a.isGSM != isVerzion || a.value == '')
                .map(plan => ({
                    value: plan.value, label: plan.label,
                    planName: plan.planName, price: plan.price, isGSM: plan.isGSM
                }))
            );
        }
    }



    const handleSelectChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const Validate = (errorList) => {
        if (!state.activationPlanId) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorActivationPlanId: true
            }));
            errorList.push(true);
        } else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorActivationPlanId: false
            }));
        }
        
        if (!state.icc) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorSimNumber: true,
                errorSimNumberLength:false
            }));
            errorList.push(true);
        }else if (state.icc.length < 19) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorSimNumber: false,
                errorSimNumberLength: true
            }));
            errorList.push(true);
        }
        
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorSimNumber: false,
                errorSimNumberLength:false
            }));
        }
        
    }
 
    const saveLineProfileInfo = () => {
        let errorList = [];
        //if (state.icc && state.icc.includes('0000')) {
        //    showMessage("Warning", "The provision for this feature will be provided soon.", "warning", 3000);
        //    return;

        //}
        
        Validate(errorList);
        if (errorList.length < 1) {
            //state.activationPlanId = state.activationPlanId ? parseInt(state.activationPlanId) : 0;
            debugger;
            const selectWirelessPlan = wirelessPlans.filter(item => item.value == state.activationPlanId);
            if (selectWirelessPlan && selectWirelessPlan.length > 0) {
                state.wirelessPlanType = selectWirelessPlan[0].label;
                state.packageName = selectWirelessPlan[0].planName;
                state.mRC = selectWirelessPlan[0].price;
                if (isPrepaid) {
                    state.activationPlanId = parseInt(state.activationPlanId);
                }
                else {
                    state.packageName = state.activationPlanId;
                    state.activationPlanId = 0;
                }
            }

            if (isPrepaid) {
                state.creditCardExpiration = state.ccExpMonth + '/' + state.ccExpYear;
            }
            
            handleNext(state)
        }
    }

    useEffect(() => {

        var params = {
            code: "get_postpaid_wireless_plans",
            parameters: [accountNumber + "", user_info.user.hidePlanPriceFlag + ""]
        };
        if (isPrepaid) {
            params = {
                code: "get_prepaid_wireless_plans",
                parameters: [accountNumber + "", user_info.user.hidePlanPriceFlag + ""]
            };
        }
        setLoaderVisible();
        PostDataAPI("ddl/loadItems", params).then((result) => {
            setLoaderHide();
            if (result.success && result.data != null) {
                result.data.unshift({ t2: 'Please Select Plan', t1: '' });
                var lstPlansData = result.data.map(t => { return { label: t.t2, value: t.t1, planName: t.t3, price: t.t4, isGSM: t.t5 == 'True' ? true : false } });
                setWirelessPlans(lstPlansData);
                setLstAllWirelessPlans(lstPlansData);
            }
        })

        if (triggerLineInfoNext) {
            saveLineProfileInfo()
            updateTrigger();
        }
    }, [triggerLineInfoNext]);
    return (
        <>

            <Grid container alignItems='center'>
                <Grid item lg={12} sm={12} xs={12}>
                    <Grid container>
                        <div className={classes.dialogSubHeader}>
                            <h3>Line Information</h3>
                        </div>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container>
    

                <Grid lg={12} sm={12} xs={12}>
                    <Grid container spacing={window.isMobileView ? 0 : 4}>
                        <Grid item sm={12} xs={12} md={6} lg={6} xl={6} >
                            <Label size={12} title="SIM Number" />
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <InputBaseField
                                    id="icc"
                                    name="icc"
                                    type="text"
                                    value={state.icc}
                                    onChange={handleChange}
                                    placeholder='SIM Number'
                                    onKeyPress={(e) => handleNumberKeyPress(e)}
                                    IsDisabled={false}
                                    MaxLength='20'
                                />

                                {errorMessages.errorSimNumber && !state.icc ? (<FormHelperText style={{ color: "red" }} >
                                    Please enter SIM number
                                </FormHelperText>) : ('')}
                                {errorMessages.errorSimNumberLength && state.icc && state.icc.length < 19 && (
                                    <FormHelperText style={{ color: "red" }}>
                                        Please enter valid SIM number
                                    </FormHelperText>
                                )}

                            </Grid>
                        </Grid>
                        <Grid item sm={12} xs={12} md={6} lg={6} xl={6} >
                            <Label title="Choose a Plan" size={12} mandatory={true} />
                            <Grid sm={12} md={12} lg={12} xl={12}>
                                <Select
                                    size="small"
                                    native
                                    name="activationPlanId"
                                    value={state.activationPlanId}
                                    onChange={handleSelectChange}
                                    placeholder="Select"
                                    label="Select"
                                    className={classes.selectBaseInput}
                                >
                                    {wirelessPlans.map(option =>
                                        <option value={option.value}>{option.label}</option>
                                    )
                                    }
                                </Select>
                                {errorMessages.errorActivationPlanId && !state.activationPlanId ? (<FormHelperText style={{ color: "red" }} >
                                    Please select a plan
                                </FormHelperText>) : ('')}
                            </Grid>
                        </Grid>
                        
                    </Grid>
                </Grid>


            </Grid>
        </>
    )
}
export default withSnackbar(LineInformation);
